export function isVisualEditorCompatible(html: string): boolean {
    const document = new DOMParser().parseFromString(html, 'text/html');
    const meta = document.head.querySelector('meta[name="application-name"]') as HTMLMetaElement | null;
    return !!meta?.dataset.version;
}
